import * as Sentry from '@sentry/react'
import {
  logError as nsLogError,
  logSentryError as nsLogSentryError,
  logSentryErrorAndGetEventId as nsLogSentryErrorAndGetEventId,
  logSentryErrorAndGetTraceId as nsLogSentryErrorAndGetTraceId,
} from '@node-space/utils'

export { getOriginFromStackTrace } from '@node-space/utils'

type LogLevelSeverity = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug'

export const logError = (
  message: string,
  error: unknown,
  payload?: unknown,
  logLevel?: LogLevelSeverity
): void => nsLogError(Sentry, message, error, payload, logLevel)

export const logSentryError = (
  message: string,
  error: unknown,
  properties?: Record<string, unknown> | object,
  logLevel?: LogLevelSeverity
): void => nsLogSentryError(Sentry, message, error, properties as Record<string, unknown>, logLevel)

export const logSentryErrorAndGetTraceId = (
  message: string,
  error: unknown,
  properties?: Record<string, unknown> | object,
  logLevel?: LogLevelSeverity
): string =>
  nsLogSentryErrorAndGetTraceId(
    Sentry,
    message,
    error,
    properties as Record<string, unknown>,
    logLevel
  )

export const logSentryErrorAndGetEventId = (
  message: string,
  error: unknown,
  properties?: Record<string, unknown> | object,
  logLevel?: LogLevelSeverity
): string =>
  nsLogSentryErrorAndGetEventId(
    Sentry,
    message,
    error,
    properties as Record<string, unknown>,
    logLevel
  )
